<script setup>
import { computed } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  instance: {
    type: Object,
    required: true,
  }
});

const emit = defineEmits(['connect', 'restart', 'delete']);

const isConnected = computed(() => props.instance.connectionStatus === 'open');

const statusClass = computed(() => {
  return isConnected.value ? 'bg-green-500/10 text-green-500' : 'bg-red-500/10 text-red-500';
});
const statusText = computed(() => {
  return isConnected.value ? 'CONECTADO' : 'DESCONECTADO';
});
</script>

<template>
  <div class="bg-n-slate-2 rounded-xl border border-n-slate-3 p-5 flex flex-col min-h-[250px] shadow-sm relative overflow-hidden">
    <!-- Accent Line -->
    <div class="absolute left-0 top-0 bottom-0 w-1" :class="isConnected ? 'bg-green-500' : 'bg-red-500'"></div>
    
    <div class="flex items-center gap-4 mb-6 pl-2 relative">
      <div class="absolute top-0 right-0">
        <Button
          icon="i-woot-bin"
          color="slate"
          variant="ghost"
          size="sm"
          class="hover:bg-red-500/10 hover:text-red-500"
          @click="emit('delete')"
          v-tooltip="'Deletar Conexão'"
        />
      </div>
      <img
        v-if="instance.profilePicUrl"
        :src="instance.profilePicUrl"
        class="w-12 h-12 rounded-full border border-n-slate-4 object-cover"
        alt="Profile"
      />
      <div v-else class="w-12 h-12 rounded-full bg-n-slate-4 flex items-center justify-center text-n-slate-11">
        <i class="i-lucide-user text-xl"></i>
      </div>
      <div class="pr-8">
        <h3 class="font-bold text-n-slate-12 text-lg leading-tight truncate w-full">{{ instance.profileName || instance.name }}</h3>
        <p class="text-xs text-n-slate-10">{{ instance.ownerJid ? instance.ownerJid.split('@')[0] : 'Sem número' }}</p>
      </div>
    </div>

    <div class="mb-auto pl-2">
      <div class="inline-flex px-2 py-1 rounded text-[10px] font-bold tracking-wider" :class="statusClass">
        {{ statusText }}
      </div>
    </div>

    <div class="flex items-center gap-2 mt-6 pt-4 border-t border-n-slate-3 pl-2">
      <button 
        @click="emit('restart')"
        class="flex-1 py-2 px-3 rounded text-sm font-medium border border-n-slate-4 hover:bg-n-slate-3 text-n-slate-11 flex justify-center items-center gap-2 transition-colors"
      >
        <i class="i-lucide-refresh-cw"></i>
        Reiniciar
      </button>
      <button 
        v-if="!isConnected"
        @click="emit('connect')"
        class="flex-1 py-2 px-3 rounded text-sm font-bold bg-green-500 hover:bg-green-600 text-white flex justify-center items-center gap-2 transition-colors"
      >
        <i class="i-lucide-qr-code"></i>
        Reconectar
      </button>
    </div>
  </div>
</template>
